import { h } from 'preact';
export const Anchor = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "12", cy: "5", r: "3" }),
        h("line", { x1: "12", y1: "22", x2: "12", y2: "8" }),
        h("path", { d: "M5 12H2a10 10 0 0 0 20 0h-3" })));
};
//# sourceMappingURL=anchor.js.map